<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs12>
                <h2 class="heading">Symptoms</h2>
                <p class="signup-subheading">do you have any of these too?</p>
            </v-flex>

            <v-flex xs12 d-flex>
                <v-list>
                    <template v-for="item in displaySymptoms">
                        <v-list-tile :key="item.item.Name" @click="select(item.item)">
                            <v-list-tile-action>
                                <v-checkbox v-model="item.selected"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.item.Name }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider/>
                    </template>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState, mapGetters} from 'vuex'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapState(['symptom']),
            ...mapGetters('symptom', {
                displaySymptoms: 'displayAdditionalSymptoms'
            })
        },
        methods: {
            select(item) {
                EventBus.$emit('symptom-additional-symptom-selected', item);
            }
        },
        mounted() {
            Loading.hide()
        }
    }
</script>